export const facebookStatisticsGroups = [
  {
    label: 'Популярные',
    options: [
      {value: 'advertiser', label: 'Рекламодатель'},
      {value: 'offer', label: 'Оффер'},
      {value: 'app', label: 'Приложения'},
      {value: 'inf_bayer', label: 'Байер'},
    ],
  },
  {
    label: 'Рекламодатель',
    options: [
      {value: 'advertiser', label: 'Рекламодатель'},
      {value: 'offer', label: 'Оффер'},
      {value: 'landing', label: 'Лендинг'},
      {value: 'brand', label: 'Бренд'},
    ],
  },
  {
    label: 'Influence',
    options: [
      {value: 'app', label: 'Приложения'},
      {value: 'inf_bayer', label: 'Байер'},
      {value: 'inf_traffic', label: 'Блогер'},
      {value: 'inf_source', label: 'Поток'},
      {value: 'app_service', label: 'Сервисы'},
    ],
  },
  {
    label: 'Дата',
    options: [
      {value: 'day', label: 'День'},
      {value: 'month', label: 'Месяц'},
      {value: 'year', label: 'Год'},
    ],
  },
  {
    label: 'Страна',
    options: [{value: 'country', label: 'Страна'}],
  },
];
